/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const UserPostalAddress = zod
  .object({
    addressLine1: zod.string().nullable(),
    addressLine2: zod.string().nullable(),
    country: zod.string().nullable(),
    postcode: zod.string().nullable(),
    state: zod.string().nullable(),
    suburb: zod.string().nullable(),
  })
  .nullable();

export type UserPostalAddress = zod.input<typeof UserPostalAddress>;
export type UserPostalAddressOutput = zod.output<typeof UserPostalAddress>;
